module.exports = __webpack_public_path__ + "img/red_062.1ef467f6.png";